// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Color} from './color.js'
import {Id} from './id.js'
import {InkStyle} from './ink-style.js'
import {InkTool} from './ink-tool.js'
import {MeasurementUnit} from './measurement-unit.js'
import {Point} from './point.js'
import {SeqId} from './seq-id.js'
import {SetColor} from './set-color.js'
import {SetFloat} from './set-float.js'
import {SetSize} from './set-size.js'
import {
  ShapeDefinitionType,
  unionListToShapeDefinitionType,
  unionToShapeDefinitionType
} from './shape-definition-type.js'
import {TapePattern} from './tape-pattern.js'

export class ModifyShape {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyShape {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyShape(bb: flatbuffers.ByteBuffer, obj?: ModifyShape): ModifyShape {
    return (obj || new ModifyShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyShape(bb: flatbuffers.ByteBuffer, obj?: ModifyShape): ModifyShape {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  shapes(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  shapesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  scale(obj?: SetSize): SetSize | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetSize()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  definitionType(): ShapeDefinitionType {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ShapeDefinitionType.NONE
  }

  definition<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  tool(): InkTool | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  style(): InkStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  tapePattern(): TapePattern | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  color(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  borderWidth(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  fillColor(obj?: SetColor): SetColor | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? (obj || new SetColor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  positionLocked(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  inkEffects(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  inkEffectsTinted(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 36)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  measurementUnit(): MeasurementUnit | null {
    const offset = this.bb!.__offset(this.bb_pos, 38)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startModifyShape(builder: flatbuffers.Builder) {
    builder.startObject(18)
  }

  static addShapes(builder: flatbuffers.Builder, shapesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, shapesOffset, 0)
  }

  static startShapesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, rotationOffset, 0)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, scaleOffset, 0)
  }

  static addDefinitionType(builder: flatbuffers.Builder, definitionType: ShapeDefinitionType) {
    builder.addFieldInt8(5, definitionType, ShapeDefinitionType.NONE)
  }

  static addDefinition(builder: flatbuffers.Builder, definitionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, definitionOffset, 0)
  }

  static addTool(builder: flatbuffers.Builder, tool: InkTool) {
    builder.addFieldInt8(7, tool, null)
  }

  static addStyle(builder: flatbuffers.Builder, style: InkStyle) {
    builder.addFieldInt8(8, style, null)
  }

  static addTapePattern(builder: flatbuffers.Builder, tapePattern: TapePattern) {
    builder.addFieldInt8(9, tapePattern, null)
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(10, colorOffset, 0)
  }

  static addBorderWidth(builder: flatbuffers.Builder, borderWidth: number) {
    builder.addFieldFloat32(11, borderWidth, null)
  }

  static addFillColor(builder: flatbuffers.Builder, fillColorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, fillColorOffset, 0)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(13, zIndex, null)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(14, +positionLocked, null)
  }

  static addInkEffects(builder: flatbuffers.Builder, inkEffects: bigint) {
    builder.addFieldInt64(15, inkEffects, null)
  }

  static addInkEffectsTinted(builder: flatbuffers.Builder, inkEffectsTinted: boolean) {
    builder.addFieldInt8(16, +inkEffectsTinted, null)
  }

  static addMeasurementUnit(builder: flatbuffers.Builder, measurementUnit: MeasurementUnit) {
    builder.addFieldInt8(17, measurementUnit, null)
  }

  static endModifyShape(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // shapes
    return offset
  }
}
